import { Col, Form, Input, message, Row } from "antd";
import React, { useState } from "react";
import s from "./SetNewPassword.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "antd/es/form/Form";
import { resetPassword } from "../../redux/carSlice";

const SetNewPassword = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const dispatch = useDispatch();
  const [form] = useForm();
  const navigate = useNavigate();
  const [messageApi, contextHolder] = message.useMessage();
  const user = useSelector((state) => state.cars.useDetails);
  const email = useSelector((state) => state.cars.email);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const success = (message) => {
    messageApi.open({
      type: "success",
      content: message ? message : "Новый OTP код отправлен на вашу почту",
    });
  };

  const error = (message) => {
    messageApi.open({
      type: "error",
      content: message,
    });
  };

  const requestNewOtp = async (values) => {
    try {
      const res = await dispatch(
        resetPassword({
          email,
          otp: values.otp,
          new_password: values.password,
        })
      );

      if (res.payload.message) {
        success("Новый пароль был успешно установлен");
        navigate("/login");
      } else {
      }

      if (res.type === "user/resetPassword/rejected") {
        error("Неправильный ОТП код или email!");
      }

      console.log("res", res);
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <div className={s.login}>
      {contextHolder}
      <h2 className={s.h2}>
        <img src='/cncars_logo.png' className={s.logo} /> Сбросить пароль
      </h2>

      <Form
        className={s.form}
        layout='vertical'
        form={form}
        onFinish={requestNewOtp}
        style={{ width: "500px" }}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name='otp'
              label='Введите ОТП код отправленный на ваш email'
              rules={[
                {
                  required: true,
                  message: "Введите ОТП код отправленный на ваш email",
                },
              ]}
            >
              <input placeholder='Введите ОТП код' className={s.input} />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name='password'
              label='Введите новый пароль'
              rules={[
                { required: true, message: "Введите пароль" },
                {
                  min: 4,
                  message: "Пароль должен состоять не менее, чем из 4 цифр",
                },
                // {
                //   pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                //   message:

                //     "Password must include at least one uppercase letter, one lowercase letter, and one number!",
                // },
              ]}
            >
              <Input.Password
                type={showPassword ? "text" : "password"}
                iconRender={(visible) =>
                  visible ? (
                    <EyeOutlined className={s.icon} />
                  ) : (
                    <EyeInvisibleOutlined />
                  )
                }
                suffix={
                  showPassword ? (
                    <EyeOutlined
                      onClick={togglePasswordVisibility}
                      style={{ color: "rgb(248, 116, 64)" }}
                    />
                  ) : (
                    <EyeInvisibleOutlined onClick={togglePasswordVisibility} />
                  )
                }
                placeholder='Введите ваш новый пароль'
                className={s.password_input}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              name='confirmPassword'
              label='Потвердитe новый пароль'
              dependencies={["password"]}
              rules={[
                { required: true, message: "Введите пароль еще раз" },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Пароли не совпадают!"));
                  },
                }),
              ]}
            >
              <Input.Password
                type={showPassword ? "text" : "password"}
                iconRender={(visible) =>
                  visible ? (
                    <EyeOutlined style={{ color: "rgb(248, 116, 64)" }} />
                  ) : (
                    <EyeInvisibleOutlined />
                  )
                }
                suffix={
                  showPassword ? (
                    <EyeOutlined
                      onClick={toggleConfirmPasswordVisibility}
                      className={s.icon}
                    />
                  ) : (
                    <EyeInvisibleOutlined
                      onClick={toggleConfirmPasswordVisibility}
                    />
                  )
                }
                placeholder='Введите ваш пароль еще раз'
                className={s.password_input}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <button className={s.enter_btn} type='htmlSubmit'>
            Установить новый пароль
          </button>
        </Row>
        <div className={s.no_account}>
          Уже есть аккаунт? &nbsp;
          <Link to='/login' className={s.register_btn}>
            Войти
          </Link>
        </div>
        <div className={s.no_account}>
          Нет аккаунта? &nbsp;
          <Link to='/register' className={s.register_btn}>
            Зарегестрироваться
          </Link>
        </div>
      </Form>
    </div>
  );
};

export default SetNewPassword;
